/**
 * @module cercaliagl/interaction/FreehandDraw
 */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import DrawPolygon from '@mapbox/mapbox-gl-draw/src/modes/draw_polygon';
import { geojsonTypes, cursors, types, updateActions, modes, events, } from '@mapbox/mapbox-gl-draw/src/constants';
import simplify from '@turf/simplify';
var FreehandMode = __assign({}, DrawPolygon);
FreehandMode.onSetup = function () {
    var _this = this;
    var polygon = this.newFeature({
        type: geojsonTypes.FEATURE,
        properties: {},
        geometry: {
            type: geojsonTypes.POLYGON,
            coordinates: [[]],
        },
    });
    this.addFeature(polygon);
    this.clearSelectedFeatures();
    // disable dragPan
    setTimeout(function () {
        if (!_this.map || !_this.map.dragPan)
            return;
        _this.map.dragPan.disable();
    }, 0);
    this.updateUIClasses({ mouse: cursors.ADD });
    this.activateUIButton(types.POLYGON);
    this.setActionableState({
        trash: true,
    });
    return {
        polygon: polygon,
        currentVertexPosition: 0,
        dragMoving: false,
    };
};
FreehandMode.onDrag = function (state, e) {
    state.dragMoving = true;
    this.updateUIClasses({ mouse: cursors.ADD });
    var currentVertex = "0.".concat(state.currentVertexPosition);
    state.polygon.updateCoordinate(currentVertex, e.lngLat.lng, e.lngLat.lat);
    state.currentVertexPosition += 1;
    var nextVertex = "0.".concat(state.currentVertexPosition);
    state.polygon.updateCoordinate(nextVertex, e.lngLat.lng, e.lngLat.lat);
};
FreehandMode.onTouchMove = function (state, e) {
    this.onDrag(state, e);
};
FreehandMode.onMouseUp = function (state) {
    if (state.dragMoving) {
        // state.polygon = this.newFeature({
        //   type: geojsonTypes.FEATURE,
        //   properties: {},
        //   geometry: {
        //     type: geojsonTypes.POLYGON,
        //     coordinates: [state.polygon.features[0].coordinates],
        //   },
        // });
        this.addFeature(state.polygon);
        this.simplify(state.polygon);
        this.fireUpdate();
        this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
        this.map.dragPan.enable();
    }
};
FreehandMode.onTouchEnd = function (state, e) {
    this.onMouseUp(state, e);
};
FreehandMode.fireUpdate = function () {
    this.map.fire(events.UPDATE, {
        action: updateActions.MOVE,
        features: this.getSelected().map(function (f) { return f.toGeoJSON(); }),
    });
};
FreehandMode.simplify = function (polygon) {
    var tolerance = 7 / (Math.pow(2, this.map.getZoom())); // https://www.desmos.com/calculator/nolp0g6pwr
    simplify(polygon, {
        mutate: true,
        tolerance: tolerance,
        highQuality: true,
    });
};
export default FreehandMode;
//# sourceMappingURL=FreehandDraw.js.map